var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 49,
    viewBox: "0 0 33 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0536 16.2114C32.0536 7.4256 24.9015 0.273438 16.1157 0.273438C7.32989 0.273438 0.177734 7.4256 0.177734 16.2114C0.177734 24.3198 6.274 31.0337 14.1234 32.0099V38.1261H8.14671V42.1106H14.1234V48.0873H18.1079V42.1106H24.0847V38.1261H18.1079V32.0099C25.9574 31.0337 32.0536 24.3198 32.0536 16.2114ZM4.16222 16.2114C4.16222 9.61706 9.52136 4.25793 16.1157 4.25793C22.71 4.25793 28.0692 9.61706 28.0692 16.2114C28.0692 22.8057 22.71 28.1649 16.1157 28.1649C9.52136 28.1649 4.16222 22.8057 4.16222 16.2114Z",
    fill: "url(#paint0_linear_1092_3648)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1092_3648",
    x1: 58.9121,
    y1: -30.2743,
    x2: -28.6483,
    y2: 18.8642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E04037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E96039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#EB6E29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2942F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.6f09effd24aa7630905d41c4ffc47ba9.svg";
export { ForwardRef as ReactComponent };